import React from "react";
import classes from "./CardSkeletonLoader.scss";

import SkeletonLoader from "UIComponents/SkeletonLoader";
import _ from "lodash";

const LoadingComponent = () => (
  <div className={classes.cardContainer}>
    <div className={classes.header}>
      <SkeletonLoader height={40} width={40} variant="rounded" />
      <div className={classes.headerColumn}>
        <SkeletonLoader height={13} width={374} />
        <SkeletonLoader height={13} width={97} />
      </div>
    </div>
    <div className={classes.cardBodyDescription}>
      <SkeletonLoader height={13} width={374} />
      <SkeletonLoader height={13} width={97} />
      <SkeletonLoader height={13} width={97} />
    </div>
    <div className={classes.cardBodyAttachments}>
      <SkeletonLoader height={234} width={"100%"} />
    </div>
    <div className={classes.cardFooter}>
      <SkeletonLoader height={13} width={97} />
      <SkeletonLoader height={13} width={97} />
    </div>
  </div>
);

const CardSkeletonLoader = () => {
  return (
    <>
      {_.times(2, () => (
        <LoadingComponent />
      ))}
    </>
  );
};

export default CardSkeletonLoader;
